import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["inputs", "addDateBtn", "addBtn", "maxMsg"];

  static values = {
    fieldCount: Number,
    dateCount: Number,
    existingSlots: String
  };

  connect() {
    this.fieldCountValue = this.defaultCountStart();
    this.dateCountValue = this.defaultCountStart();
    this.manageExistingSlots();
    this.maxMsgTarget.style.display = 'none';
  }

  addDateRow(e) {
    e.preventDefault();
    this.inputsTarget.appendChild(this.buildFormRow());
  }

  buildFormRow(date=null, startTime=null, endTime=null) {
    const holder = document.createElement("div");
    holder.className = "one-time";

    const div = document.createElement("div");
    div.className = "row date-row";
    div.setAttribute("date-count", this.dateCountValue);

    if (this.fieldCountValue == 0)
      holder.appendChild(document.createElement("hr"));

    holder.appendChild(div);

    const innerDiv = document.createElement("div");
    innerDiv.className = "col-md-12 col-12 mt-1 mb-1";
    innerDiv.appendChild(this.buildDateField(date));

    this.appendTimeRowToDate(innerDiv, "first", this.dateCountValue, startTime, endTime);

    div.appendChild(innerDiv);

    holder.appendChild(document.createElement("hr"));
    this.dateCountValue++;
    return holder;
  }

  addTimeRow(element) {
    element.preventDefault();
    var row = element.target.closest(".time-rows");
    let dateCount = row.closest(".date-row").getAttribute("date-count");
    row.appendChild(this.buildTimeRow("add", dateCount));
    this.fieldCountValue++;
    this.verifyFieldCount();
  }

  appendTimeRowToDate(element, type, dateCount, startTime, endTime) {
    const timeRowsHolder = document.createElement("div");
    timeRowsHolder.className = "row time-rows";
    timeRowsHolder.appendChild(this.buildTimeRow(type, dateCount, startTime, endTime));
    element.appendChild(timeRowsHolder);
    this.fieldCountValue++;
    this.verifyFieldCount();
  }

  buildDateField(date=null) {
    var input = document.createElement("input");
    input.type = "date";
    input.name =
      "autopilot_container[configuration_attributes][timeslots][" +
      this.dateCountValue +
      "][date]";
    input.id = "date";
    input.placeholder = "mm/dd/yy";
    input.className = "form-control timeslot-date";
    input.setAttribute("data-controller", "flatpickr");
    input.setAttribute("data-flatpickr-min-date", "today");
    input.setAttribute("data-flatpickr-date-format", "m/d/Y");
    input.setAttribute("data-flatpickr-default-date", date || this.todaysDate())
    var label = document.createElement("label");
    label.htmlFor =
      "autopilot_container[configuration_attributes][timeslots][" +
      this.dateCountValue +
      "][date]";
    label.innerHTML = "Date*";
    label.className = "form-control-label";

    const dateField = document.createElement("div");
    dateField.className = "row";
    const innerDateField = document.createElement("div");
    innerDateField.className = "col-md-6 col-10";

    innerDateField.appendChild(label);
    innerDateField.appendChild(input);
    dateField.appendChild(innerDateField);

    const deleteBtnDiv = document.createElement("div");
    deleteBtnDiv.className = "col-md-6 col-1 text-end";

    deleteBtnDiv.appendChild(this.rowDeleteBtn());

    dateField.appendChild(deleteBtnDiv);

    return dateField;
  }

  buildTimeRow(type, dateCount, startTime=null, endTime=null) {
    var row = document.createElement("div");
    row.className = "row col-md-7 col-12 single-time-row";

    var div1 = document.createElement("div");
    div1.className = "col-5";
    var stTime = startTime ? startTime : "09:00";
    div1.appendChild(this.buildTimeField(dateCount, stTime, "start"));
    var div2 = document.createElement("div");
    div2.className = "col-5 time-row-right";
    var eTime = endTime ? endTime : "17:00";
    div2.appendChild(this.buildTimeField(dateCount, eTime, "end"));

    row.appendChild(div1);
    row.appendChild(div2);
    if (type == "first") {
      row.appendChild(this.timeAddBtn());
    } else {
      row.appendChild(this.timeRemoveBtn());
    }
    return row;
  }

  buildTimeField(dateCount, startTime, start_or_end) {
    var input = document.createElement("input");
    input.setAttribute("data-controller", "flatpickr");
    input.setAttribute("data-flatpickr-enable-time", true);
    input.setAttribute("data-flatpickr-no-calendar", true);
    input.setAttribute("data-flatpickr-date-format", "h:i K");
    input.setAttribute("data-flatpickr-default-date", startTime);
    input.type = "time";
    input.value = startTime;
    input.name =
      `autopilot_container[configuration_attributes][timeslots][${dateCount}][times][` +
      this.fieldCountValue +
      "][" +
      start_or_end +
      "]";
    input.className = "form-control";
    return input;
  }

  rowDeleteBtn() {
    const containerDiv = document.createElement("div");
    containerDiv.className = "col-6";
    var deleteBtn = document.createElement("a");
    deleteBtn.className = "btn btn-sm btn-round-light";
    deleteBtn.setAttribute(
      "data-action",
      "click->one-time-availability#removeElement"
    );
    deleteBtn.setAttribute("data-list-number", this.fieldCountValue);
    deleteBtn.innerHTML = "<i class='fa fa-sm fa-trash'></i>";
    deleteBtn.title = "Delete";

    return containerDiv.appendChild(deleteBtn);
  }

  timeAddBtn() {
    var div = document.createElement("div");
    div.className = "col-2";

    var addBtn = document.createElement("button");
    addBtn.className = "btn btn-sm btn-round-light";
    addBtn.setAttribute(
      "data-action",
      "click->one-time-availability#addTimeRow"
    );
    addBtn.innerHTML = "<i class='fa fa-sm fa-plus'></i>";
    addBtn.title = "Add Time Slot";
    addBtn.setAttribute('data-one-time-availability-target', 'addBtn')

    div.appendChild(addBtn);
    return div;
  }

  timeRemoveBtn() {
    var div = document.createElement("div");
    div.className = "col-2 d-flex";

    var removeBtn = document.createElement("a");
    removeBtn.className = "btn btn-sm remove-timeslot";
    removeBtn.setAttribute(
      "data-action",
      "click->one-time-availability#removeTimeRow"
    );
    removeBtn.innerHTML = "<i class='far fa-sm fa-times'></i>";
    removeBtn.title = "Remove Time Slot";

    div.appendChild(removeBtn);
    return div;
  }

  removeElement(element) {
    var row = element.target.closest(".one-time");
    this.fieldCountValue--;
    row.remove();
    this.verifyFieldCount();
  }

  removeTimeRow(element) {
    var timeRow = element.target.closest(".single-time-row");
    this.fieldCountValue--;
    timeRow.remove();
    this.verifyFieldCount();
  }

  manageExistingSlots() {
    if(this.existingSlotsValue == '')
      return
    var existingSlots = JSON.parse(this.existingSlotsValue.replaceAll("=>", ':'))
    for(const [key,value] of Object.entries(existingSlots)) {
      this.createOrAddExistingDate(value.date, value.start, value.end)
    };
  }

  createOrAddExistingDate(date, startTime, endTime) {
    let input = document.querySelector(`input.timeslot-date[data-flatpickr-default-date="${date}"]`);
    if (input) {
      let dateRow = input.closest(".date-row");
      let dateCount = dateRow.getAttribute("date-count");
      this.appendTimeRowToDate(dateRow.firstChild, "add", dateCount, startTime, endTime);
    } else {
      this.inputsTarget.appendChild(this.buildFormRow(date, startTime, endTime));
    }
  }

  verifyFieldCount(){
    if(this.fieldCountValue >= 50){
      this.addDateBtnTarget.disabled = true
      this.addBtnTargets.forEach(element => element.disabled = true)
      this.maxMsgTarget.style.display = 'block';
    } else {
      this.addDateBtnTarget.disabled = false
      this.addBtnTargets.forEach(element => element.disabled = false)
      this.maxMsgTarget.style.display = 'none';
    }
  }

  todaysDate() {
    return new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
  }

  defaultCountStart(){
    if(this.existingSlotsValue == '{}'){
      return 1;
    } else {
      return 0;
    }
  }
}
